<template>
  <div style="overflow: hidden;">
	  <div class="video" >
		<!-- 视频播放区 -->
<!--		<video id="video1" :src="src" :poster="poster"></video>-->
		  <div id='video1' :class="isPlay ? '' : 'video-container'">
			  <video-player class="video-player vjs-custom-skin vjs-has-started video-player-container"
							ref="videoPlayer"
							:playsinline="true"
							@play="onPlayerPlay($event)"
              @ready="onPlayerReady"
							:options="playerOptions">
			  </video-player>

        <div v-if="showDropdown" class="custom-dropdown" :style="dropdownStyle" data-mark="dropdown">
          <ul data-mark="dropdown">
            <li v-for="option in dropdownOptions" :key="option.value" @click="handleSelect(option)" style="display: flex;" data-mark="dropdown">
              <div class="icon" data-mark="dropdown">
                <img :src="option.icon" alt="" style="width: 100%" data-mark="dropdown">
              </div>
              <div class="label" data-mark="dropdown">
                {{ option.label }}
              </div>
            </li>
          </ul>
        </div>

        <div v-if="speedDropdown" class="speed-dropdown" :style="speedDropdownStyle" data-mark="dropdown">
          <ul data-mark="dropdown">
            <li v-for="(option,index) in speedOptions" :key="option.value" @click="handleSelectSpeed(option)" style="display: flex;" data-mark="dropdown">
              <div class="arrow-left" data-mark="dropdown">
                <img :src="require('./myVideo/arrow-left.png')" alt="" style="width: 100%;" v-if="index == 0" data-mark="dropdown">
              </div>
              <div class="label" data-mark="dropdown">
                {{ option.label }}
              </div>
              <div class="icon" data-mark="dropdown">
                <img :src="require('./myVideo/select.png')" alt="" style="width: 100%;" v-if="option.select" data-mark="dropdown">
              </div>
            </li>
          </ul>
        </div>
		  </div>
		<!-- 遮罩层 -->
<!--		<div class="cover">-->
<!--			&lt;!&ndash; 居中的播放暂停状态 &ndash;&gt;-->
<!--			<div id="playStatus"></div>-->
<!--			&lt;!&ndash; 控件部分 &ndash;&gt;-->
<!--			<div class="controls">-->
<!--				&lt;!&ndash; 控件部分中的播放暂停状态 &ndash;&gt;-->
<!--				<div id="contPlayStatus"></div>-->
<!--				<div id="currentTime">00:00:00</div>-->
<!--				&lt;!&ndash; 进度条 &ndash;&gt;-->
<!--				<input id="progressBar" type="range" name="" min="0" max="1000" value="0">-->
<!--				<div id="duration">00:00:00</div>-->
<!--				<div id="volume_box">-->
<!--					<div id="volume"></div>-->
<!--					<div id="volumeInput"><input id="volumeInputRange" type="range" name="" min="0" max="100" value="100"></div>-->
<!--				</div>-->
<!--				<div id="fullScreen"></div>-->
<!--			</div>-->
<!--		</div>-->


	</div>
</div>
</template>

<script>
export default {
	data(){
		return {
			isPlay:false,
			playerOptions: {
				//播放速度
				// playbackRates: [0.5, 1.0, 1.5, 2.0],
				//如果true,浏览器准备好时开始回放。
				autoplay: true,
				// 默认情况下将会消除任何音频。
				muted: false,
				// 导致视频一结束就重新开始。
				loop: false,
				// 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
				preload: 'auto',
				language: 'zh-CN',
				// 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
				// aspectRatio: '16:9',
				// 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
				fluid: true,
				sources: [{
					//类型
					type: "video/mp4",
					//url地址
					src: this.src
				}],
				//你的封面地址
				poster: this.poster,
				//允许覆盖Video.js无法播放媒体源时显示的默认信息。
				notSupportedMessage: '此视频暂无法播放，请稍后再试',
        controls: true,
				controlBar: {
					timeDivider: true,
					durationDisplay: true,
					remainingTimeDisplay: false,
					//全屏按钮
					fullscreenToggle: true
				},
			},
      showDropdown: false,
      dropdownStyle: {},
      dropdownOptions: [
        { label: '下载', value: 1, icon: require('./myVideo/download.png') },
        { label: '播放速度', value: 2, icon: require('./myVideo/speed.png') },
      ],

      speedDropdown: false,
      speedOptions: [
        { label: '选项', value: 0, speed: '', select: false },
        { label: '0.25', value: 1, speed: '0.25', select: false },
        { label: '0.5', value: 2, speed: '0.5', select: false },
        { label: '0.75', value: 3, speed: '0.7', select: false },
        { label: '正常', value: 4, speed: '1', select: true },
        { label: '1.25', value: 5, speed: '1.25', select: false },
        { label: '1.5', value: 6, speed: '1.5', select: false },
        { label: '1.75', value: 7, speed: '1.75', select: false },
        { label: '2', value: 8, speed: '2', select: false },
      ],
      speedDropdownStyle: {}
		}
	},
	// props:['src','poster'],
	props: {
    src :{
      type: String,
      default: ''
    },
    poster: {
      type: String,
      default: ''
    },
  },
  computed: {
    player() {
      return this.$refs.videoPlayer.player
    },
  },
	watch:{
		src(n,o){
			this.playerOptions.sources[0].src = n
		},
		poster(n,o){
			this.playerOptions.poster = n
		}
	},
	methods:{
		async onPlayerPlay(){
			try {
        this.isPlay = true
			}catch (e) {
				console.log(e)
			}
		},
    createCustomButton(videojs) {
      return class CustomButton extends videojs.getComponent('Button') {
        constructor(player, options) {
          super(player, options);
          this.addClass('vjs-icon-placeholder');
          this.addClass('vjs-custom-button');
          this.controlText('');

          this.el().innerHTML = '<i class="fas fa-cog" data-mark="dropdown">' +
              '<img src="'+ require('./myVideo/more.png') +'" alt="" style="width: 100%" data-mark="dropdown">' +
              '</i>'

          this.handleButtonClick = options.handleButtonClick
        }

        handleClick() {
          if (this.handleButtonClick) {
            this.handleButtonClick(this.el()) // 调用传入的方法
          }
        }
      };
    },
    addCustomButton() {
      const player = this.$refs.videoPlayer.player;
      const videojs = player.constructor;

      const CustomButton = this.createCustomButton(videojs);
      videojs.registerComponent('CustomButton', CustomButton);


      const controlBar = player.controlBar

      controlBar.addChild('customButton', {
        handleButtonClick: this.toggleDropdown
      });
    },
    onPlayerReady(){
      this.addCustomButton()
    },
    toggleDropdown(buttonEl) {
      console.log('toggleDropdown')
      this.dropdownStyle = {
        position: 'absolute',
        zIndex: 9999,
        backgroundColor: '#fff',
        border: '1px solid #ccc',
        borderRadius: '4px',
        boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
        listStyle: 'none',
        margin: 0,
        fontSize: '16px',
        right:0,
        bottom:0,
      };

      this.showDropdown = !this.showDropdown;
    },

    // 处理选项点击
    handleSelect(option) {
      console.log('handleSelect')
      this.showDropdown = false;
      this.speedDropdownStyle = {
        position: 'absolute',
        zIndex: 9999,
        backgroundColor: '#fff',
        border: '1px solid #ccc',
        borderRadius: '4px',
        boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
        listStyle: 'none',
        margin: 0,
        fontSize: '16px',
        right:0,
        bottom:0,
      };
      switch (option.value) {
        case 1:
          this.downloadFile(this.playerOptions.sources[0].src)
          break;
        case 2:
          this.speedDropdown = !this.speedDropdown;
          break;
      }
    },
    handleSelectSpeed(option){
      switch (option.value) {
        case 0:
          this.showDropdown = true
          break;
        default:
          const player = this.$refs.videoPlayer.player;
          player.playbackRate(option.speed);
          this.speedOptions.forEach(item => item.select = false)
          option.select = true
          break;
      }
      this.speedDropdown = false;
    },
    async downloadFile(path) {
      this.$emit('downloadFile', path)
    },
    handleClickOutside(e) {
      console.log('e.target')
      console.log(e.target)
      if(e.target.getAttribute('data-mark') != 'dropdown'){
        this.showDropdown = false;
        this.speedDropdown = false;
      }
    }
	},
  beforeDestroy() {
    document.removeEventListener('click', this.handleClickOutside)
  },
	mounted(){
		this.playerOptions.sources[0].src = this.src
		this.playerOptions.poster = this.poster
    document.addEventListener('click', this.handleClickOutside)
		// var divVideo = document.getElementsByClassName("video")[0];
		// var divCover = document.getElementsByClassName("cover")[0];
		// var video1 = document.getElementById("video1");
		// var playStatus = document.getElementById("playStatus");
		// var controls = document.getElementsByClassName("controls")[0];
		// var contPlayStatus = document.getElementById("contPlayStatus");
		// var currentTime = document.getElementById("currentTime");
		// var progressBar = document.getElementById("progressBar");
		// var duration = document.getElementById("duration");
		// var volume = document.getElementById("volume");
		// var volume_box = document.getElementById("volume_box");
		// var volumeInput = document.getElementById("volumeInput");
		// var fullScreen = document.getElementById("fullScreen");
		//
		// divVideo.addEventListener("mouseenter", function() {
		// 	console.log('divVideo mouseenter')
		// 	divCover.style.display = "block";
		// })

		// divVideo.addEventListener("mouseleave", function() {
		// 	console.log('divVideo mouseleave')
		// 	divCover.style.display = "none";
		// })

		// video1.addEventListener("play", function() {
		// 	console.log('video1 play')
		// 	playStatus.style.backgroundImage = "none"
		// 	contPlayStatus.style.backgroundImage = "url("+require('../img/myVideo/pause32.svg')+")"
		// })

		// video1.addEventListener("pause", function() {
		// 	playStatus.style.backgroundImage = "url("+require('../img/myVideo/play.svg')+")"
		// 	contPlayStatus.style.backgroundImage = "url("+require('../img/myVideo/play32.svg')+")"
		//
		// })
		//
		// playStatus.addEventListener("click", play_pause);
		// contPlayStatus.addEventListener("click", play_pause);
		//
		// setInterval(function() {
		// 	progressBar.value = video1.currentTime / video1.duration * 1000;
		// 	currentTime.innerHTML = getTime(video1.currentTime);
		// 	duration.innerHTML = getTime(video1.duration);
		// }, 10)
		//
		// progressBar.addEventListener("input", function(e) {
		// 	console.log('progressBar')
		// 	video1.currentTime = video1.duration * (progressBar.value / 1000);
		// 	video1.play();
		// })
		//
		// var currVolume;
		//
		// volume_box.addEventListener("mouseenter", function() {
		// 	volumeInput.style.display = "block";
		// })
		//
		// volume_box.addEventListener("mouseleave", function() {
		// 	volumeInput.style.display = "none";
		// })
		//
		// volume.addEventListener("click", function() {
		// 	if (video1.volume != 0) {
		// 		currVolume = video1.volume;
		// 		video1.volume = 0;
		// 		volumeInputRange.value = 0;
		// 		this.style.backgroundImage = "url("+require('../img/myVideo/volumeoff.svg')+")"
		// 	} else {
		// 		video1.volume = currVolume;
		// 		volumeInputRange.value = currVolume * 100;
		// 		this.style.backgroundImage = "url("+require('../img/myVideo/volume.svg')+")"
		// 	}
		// },false)
		//
		// video1.volume = 0.3;
		// volumeInputRange.value = 30;
		// volumeInputRange.addEventListener("input", function() {
		// 	video1.volume = Number(this.value) / 100;
		// 	volume.style.backgroundImage = video1.volume == 0 ? "url("+require('../img/myVideo/volumeoff.svg')+")" : "url("+require('../img/myVideo/volume.svg')+")"
		// })
		//
		// var fullScreenStatus = false;
		// fullScreen.addEventListener("click", function() {
		// 	if (!fullScreenStatus) {
		// 		var body = document.body;
		// 		body.webkitRequestFullScreen();
		// 		divVideo.style.width = innerWidth + "px";
		// 		divVideo.style.height = innerWidth / (1920 / 1080) + "px";
		// 		divVideo.style.position = "absolute";
		// 		divVideo.style.left = "50%";
		// 		divVideo.style.top = "50%";
		// 		divVideo.style.transform = "translate(-50%, -50%)";
		// 		divCover.style.width = innerWidth + "px";
		// 		divCover.style.height = innerWidth / (1920 / 1080) + "px";
		// 		controls.style.width = innerWidth + "px";
		// 		var num = innerWidth ;
		// 		progressBar.style.width = parseInt(getComputedStyle(progressBar).width) + num + "px";
		// 		// volumeInput.style.left = parseInt(getComputedStyle(volumeInput).left) + num + 15 + "px";
		// 		// volumeInput.style.display = 'block'
		// 		fullScreenStatus = true;
		// 	} else {
		// 		document.webkitCancelFullScreen();
		// 		divVideo.style.width = "";
		// 		divVideo.style.height = "";
		// 		divVideo.style.position = "";
		// 		divVideo.style.left = "";
		// 		divVideo.style.top = "";
		// 		divVideo.style.transform = "";
		// 		divCover.style.width = "";
		// 		divCover.style.height = "";
		// 		controls.style.width = "";
		// 		// var num = innerWidth - 1100;
		// 		progressBar.style.width = "";
		// 		// volumeInput.style.left = "";
		// 		// volumeInput.style.display = 'none'
		// 		fullScreenStatus = false;
		// 	}
		// })
		//
		// function play_pause() {
		// 	if (video1.paused) {
		// 		video1.play();
		// 		// audio1.pause();
		// 		check_box.checked = false;
		// 	} else {
		// 		video1.pause();
		// 	}
		// }
		//
		// function getTime(time) {
		// 	let hour = Math.floor(time / 3600) < 10 ? "0" + Math.floor(time / 3600) : Math.floor(time / 3600);
		// 	let min = Math.floor(time % 3600 / 60) < 10 ? "0" + Math.floor(time % 3600 / 60) : Math.floor(time % 3600 / 60);
		// 	var sec = Math.floor(time % 60) < 10 ? "0" + Math.floor(time % 60) : Math.floor(time % 60);
		// 	return hour + ":" + min + ":" + sec;
		// }
	}
}
</script>

<style scoped>
	.demo{
		display: inline-block;
		width: 600px;
		height: 338px;
		text-align: center;
		line-height: 100px;
		border: 1px solid transparent;
		border-radius: 4px;
		overflow: hidden;
		background: #fff;
		position: relative;
		box-shadow: 0 1px 1px rgba(0, 0, 0, .2);
		margin-right: 4px;
	}

	.demo:hover{
		display: block;
	}
.video {
    //width: 1920px;
    /*height: 1080px;*/
    margin: 0 auto;
    position: relative;
}
.video video {
    /* width: 1080px;
    height: 460px; */
	object-fit:fill;
    /*position: absolute;*/
    /*left: 50%;*/
    /*transform: translateX(-50%);*/
    height: 100%;
    /* object-fit: contain; */
    /*object-position: center center;*/
}

video::-webkit-media-controls {
    /* 去掉全屏时显示的自带控制条 */
    display: none !important;
}

.cover {
    width: 1920px;
    height: 1080px;
    /* background-color: rgba(116, 116, 116, 0.3); */
    position: absolute;
    left: 0;
    top: 0;
}

#playStatus {
    width: 72px;
    height: 51px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  background-image: url(../img/myVideo/play.svg);
	background-repeat: no-repeat;
}

.controls {
    width: 1920px;
    height: 64px;
    background-image: linear-gradient(transparent, #00000030);
    position: absolute;
    bottom: 0;
    display: flex;
    justify-content: space-around;
}

#contPlayStatus {
    width: 54px;
    height: 36px;
    background-image: url(../img/myVideo/play32.svg);
	background-repeat: no-repeat;
    position: relative;
    top: 16px;
	background-position-x:center;
	background-position-y:center;

    /* border: 1px solid red; */
}

#currentTime {
    width: 84px;
    height: 64px;
    /* border: 1px solid red; */
    text-align: center;
    line-height: 64px;
    font-size: 16px;
    color: #ffffff;
}

#progressBar {
    /* 进度条样式 */
    -webkit-appearance: none;
    width: 1400px;
    height: 5px;
    /* border: 1px solid red; */
    position: relative;
    top: 28px;
    background-color: #eee;
    border-radius: 2.5px;
}

#progressBar::-webkit-slider-thumb {
    /* 进度条滑块样式 */
    -webkit-appearance: none;
    width: 12px;
    height: 12px;
    cursor: pointer;
    background: none repeat scroll 0 0 #ffffff;
    border-radius: 6px;
}

#duration {
    width: 84px;
    height: 64px;
    /* border: 1px solid red; */
    text-align: center;
    line-height: 64px;
    font-size: 16px;
    color: #ffffff;
}

#volume {
    width: 32px;
    height: 32px;
    /* border: 1px solid red; */
    position: relative;
    top: 16px;
    background-image: url(../img/myVideo/volume.svg);
}
#volume_box{
	/* background: red; */
	position: relative;
}

#volumeInput {
    width: 32px;
    height: 120px;
    position: absolute;
    /* left: 940px;
    top: -105px; */
	left: 0;
	top: -100px;
    display: none;
	/* background: red; */
}

#volumeInputRange {
    transform: rotate(270deg);
    -webkit-appearance: none;
    width: 120px;
    height: 5px;
    /* border: 1px solid red; */
    position: absolute;
    left: -50px;
    top: 40px;
    background-color: #eee;
    border-radius: 2.5px;
}

#volumeInputRange::-webkit-slider-thumb {
    -webkit-appearance: none;
    width: 12px;
    height: 12px;
    cursor: pointer;
    background: none repeat scroll 0 0 #ffffff;
    border-radius: 6px;
}

#volume:hover+#volumeInput {
    display: block;
}

#volumeInput:hover {
    display: block;
}

#fullScreen {
    width: 54px;
    height: 36px;
    /* border: 1px solid red; */
    position: relative;
    top: 16px;
    background-image: url(../img/myVideo/fullscreen.svg);
	background-repeat: no-repeat;
}

.video-player-container {
  width: 1600px;
  height: 900px;
}

#video1 {
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>

<style>

.vjs-custom-skin > .video-js .vjs-big-play-button{
  background-image: url(../img/myVideo/play.svg);
  border-radius: 0!important;
  background-size: 90%;
  background-position: center;
}
.video-js:hover .vjs-big-play-button, .vjs-custom-skin>.video-js .vjs-big-play-button:active, .vjs-custom-skin>.video-js .vjs-big-play-button:focus{
  background-color: rgba(0,0,0,0) !important;
}
.video-js .vjs-volume-panel .vjs-volume-control{
  opacity: 1;
}
.video-js .vjs-volume-panel {
  width: 8.5em!important;
  order: 6;
}
.video-js .vjs-volume-control.vjs-volume-horizontal {
  width: 5em;
  order: 1;
}
.video-js .vjs-mute-control {
  order: 1;
}
.vjs-custom-button {
  width: 2em!important;
  order: 9;
  display: flex;
  justify-content: center;
  align-items: center;
}
.vjs-custom-button .vjs-control-text {
  clip: auto !important;
  position: absolute;
  left: 0;
  top: 0;
  background-color: red;
  width: 100%!important;
  height: 100%!important;
}
.vjs-custom-button:before {
  font-size: 16px;
  color: white;
  display: block;
  width: 100px;
  height: 100px;
}

.video ul {
  margin: 0;
  padding: 0;
}
.video ul li {
  list-style: none;
}

.video ul li {
  padding: 10px 30px;
  transition: all .3s linear 0s;
  cursor: pointer;
}
.video ul li:hover {
  background-color: rgba(0,0,0, .2);
}


.speed-dropdown ul {
  height: 210px;
  overflow-y: auto;
}
.speed-dropdown .arrow-left {
  width: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: 10px;
}
.speed-dropdown .label {
  width: 70px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 18px;
}
.speed-dropdown .icon {
  width: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-left: 10px;
}
.custom-dropdown .icon {
  width: 25px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: 10px;
}
.custom-dropdown .label {
  font-size: 18px;
  display: flex;
  justify-content: center;
  align-items: center
}
.fa-cog {
  display: block;
  justify-content: center;
  align-items: center;
  width: 25px;
  cursor: pointer;
}

/* 手机端样式 */
@media (max-width: 767px){
  .video ul li {
    padding: .2rem .3rem;
  }
  .fa-cog {
    width: 1.5em;
  }

  .custom-dropdown {

  }
  .speed-dropdown .label,
  .custom-dropdown .label {
    font-size: .3rem;
  }
  .custom-dropdown .icon {
    width: .3rem;
    margin-right: .2rem;
  }

  .speed-dropdown .label {
    width: 1.3rem;
  }

  .speed-dropdown .arrow-left {
    width: .3rem;
    margin-right: .2rem;
  }
  .speed-dropdown .icon {
    width: .3rem;
    margin-left: .2rem;
  }
  .speed-dropdown ul {
    height: 3.8rem;
  }
}
</style>

